export default __webpack_public_path__ + "static/media/symbol-defs.10023b02.svg";